import React from 'react';
import styled from 'styled-components';

import { STATIC_ROOT } from '../../constants';

import SvgComponent from '../SvgComponent';

const MarkerWrapper = styled.div`
    z-index: ${props => props.zIndex};
    position: absolute;
    bottom: 0;
    left: 0;
    height: 44px;
    width: 34px;
    transform: translate(-50%, 0);
    text-align: center;
    outline: none;
    color: #d1282d;

    div {
        position: relative;
        bottom: 50px;
        font-size: 30px;
        color: #fff;
    }
`;

class UserMarker extends React.Component {
    render() {
        return (
            <MarkerWrapper>
                <SvgComponent
                    src={`${STATIC_ROOT}/maps/pin.svg`}
                    width="34"
                    height="44"
                    aria-hidden="true"
                    focusable="false"
                />
                <div>☺</div>
            </MarkerWrapper>
        );
    }
}

export default UserMarker;



// WEBPACK FOOTER //
// ./src/components/googlemaps/UserMarker.js